<template>
  <div class="page-content">
     <page-template
      ref="deposit"
      :tableOptions="storeReportTable"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    >
    </page-template>
  </div>
</template>

<script>
import api from "@/config/api";
import pageTemplate from "@/components/template/pageTemplate";
import userPower from "@/mixin/userPower";

export default {
   mixins: [userPower],
  components: { pageTemplate },
  data() {
    return {
      indexShow: false,
      searchOptions: {
        simple: [
          { label: "储值门店", prop: "saveStoreId", type: "select", span: 12 ,data:[]},
        ],
        complex: [
          { label: "开卡门店", prop: "storeId", type: "select", span: 12,data:[] },
          { label: "会员分类", prop: "memberCategoryId", type: "select", span: 12,  url: api.member.category,data:[] },
           {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
        ],
      },
      storeReportTable: {
        showSummary: true,
        summaryColumns: ['depositMoney', 'memberGivingMoney', 'allMoney'],
        indexShow: true, //是否显示索引
        columns: [
          {
            label: "会员手机号",
            prop: "memberPhone",
            align: "center",
          },
          {
            label: "姓名",
            prop: "memberName",
            align: "center",
          },
          {
            label: "充值金额",
            prop: "depositMoney",
            align: "center",
          },
          {
            label: "赠送金额",
            prop: "memberGivingMoney",
            align: "center",
          },
          {
            label: "消费金额",
            prop: "allMoney",
            align: "center",
          },
        ],
        url: api.report.depositStatics
      },
      toolConfig: [
        {
          label: "导出",
          code: "export",
          callback:this.exportData
        },
      ],
    };
  },
  created() {
    this.setStore(this.searchOptions.complex);
    this.allStore()
  },
  mounted() {

  },
  methods: {
    allStore(){
      let mes=[]
      mes.unshift({name:"所有门店",value:""});
      this.$axios.fetchPost(api.system.seStore+'/list').then(data=>{
        if(data.code===200){
          data.data.unshift({name:"所有门店",value:""});
           this.searchOptions.simple.filter(item=>item.prop==="saveStoreId")[0].data=data.data;
           this.searchOptions.complex.filter(item=>item.prop==="storeId")[0].data=data.data;
        }
      })
    },
    exportData() {
      let params = this.$refs["deposit"].getCurrentParams();
      params.exportCode = 'memberSaveMoneyExport';
      this.$axios.fetchPost(api.report.depositExport, params).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });

          // this.$message({message: '导出异常', type: 'error'});
        }
      })
    }
  },
};
</script>

<style scoped>
.page-template .centerBack {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
}
.page-template .echartsArea {
  height: 270px;
  margin-bottom: 12px;
}


</style>



// WEBPACK FOOTER //
// src/page/report/member/deposit/DepositStatistics.vue